"use client";

import { usePathname } from "next/navigation";
import FinancesHelp from "./admin/finanzas/FinancesHelp";

const Help = () => {
  const pathname = usePathname();

  if (pathname === "/admin/finanzas") return <FinancesHelp />;

  return null;
};

export default Help;
